import { useMutation } from '@tanstack/react-query'

import { enableScim } from '@src/api'
import { DefaultApiEnableScimRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useEnableScim = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiEnableScimRequest) =>
      enableScim(axiosInstance, params),
  })
}
